import React, { useState, useEffect } from 'react';
import { 
  FaLinkedinIn, 
  FaEnvelope, 
  FaStar, 
  FaBuilding, 
  FaBriefcase, 
  FaUserGraduate, 
  FaFacebookF, 
  FaInstagram,
  FaAward,
  FaGlobe
} from 'react-icons/fa';

// --- 1. IMPORT THE CSS FILE ---
import './Assets/mentor.css';

// --- Data for the Instructor (Unchanged) ---
const instructorData = {
    name: "Manoj Koravangi",
    tagline: "Unlocking Digital Resilience",
    roles: [
        "District Special Officer (Cyber Cell)",
        "Certified Ethical Hacker"
    ],
    bio: "Founder & CEO of Awetecks & SkillsUprise. A leading corporate trainer and cybersecurity expert, Manoj empowers individuals and teams to master cutting-edge tech skills and build robust careers.",
    profilePicUrl: "https://skillsuprise.com/resources/images/g7.png",
    achievements: [
        { icon: FaBriefcase, text: "4+ Years Leading 25+ Software Teams" },
        { icon: FaBuilding, text: "Founder, Awetecks & SkillsUprise" },
        { icon: FaUserGraduate, text: "5000+ Individuals Trained" },
        { icon: FaAward, text: "Expert in Corporate Training" },
        { icon: FaGlobe, text: "Proficient in 20+ Technologies" }
    ],
    rating: 4.8,
    reviewsCount: "1,500+",
    linkedinUrl: "https://www.linkedin.com/in/manojkoravangi",
    email: "manoj.k@example.com",
    facebookUrl: "https://www.facebook.com/manoj.koravangi",
    instagramUrl: "https://www.instagram.com/manoj.koravangi",
    bookingLink: "#",
    contactLink: "#"
};

// --- AboutHackingMentor Component ---
const AboutHackingMentor = () => {
    const {
        name, tagline, roles, bio, profilePicUrl, achievements,
        rating, reviewsCount, linkedinUrl, email, facebookUrl, instagramUrl,
        bookingLink, contactLink
    } = instructorData;

    // State for controlling load-in animation
    const [isAnimated, setIsAnimated] = useState(false);

    useEffect(() => {
        const timer = setTimeout(() => {
            setIsAnimated(true);
        }, 100);
        return () => clearTimeout(timer);
    }, []);

    // Function to render rating stars
    const renderStars = (ratingValue) => {
        const stars = [];
        for (let i = 1; i <= 5; i++) {
            stars.push(
                <FaStar 
                    key={i} 
                    className={i <= Math.floor(ratingValue) ? "star-filled" : "star-empty"} 
                />
            );
        }
        if (ratingValue % 1 !== 0) {
            stars[Math.floor(ratingValue)] = (
                <FaStar key={Math.floor(ratingValue) + 0.5} className="star-half" />
            );
        }
        return stars;
    };

    // --- 2. DYNAMICALLY ADD .is-animated CLASS ---
    const wrapperClasses = `mentor-profile-wrapper ${isAnimated ? 'is-animated' : ''}`;

    return (
        <div 
            id="hacking-mentor-profile" // --- 3. UNIQUE ID ---
            className={wrapperClasses} // --- 4. CSS CLASSES ---
        >
            <div className="mentor-card-new row no-gutters">
                
                <div className="col-12 col-lg-4 mentor-image-section">
                    <img
                        src={profilePicUrl}
                        alt={`Profile picture of ${name}`}
                        className="mentor-profile-pic"
                    />
                    <div className="mentor-social-links">
                        {linkedinUrl && (
                            <a href={linkedinUrl} target="_blank" rel="noopener noreferrer" className="mentor-social-link">
                                <FaLinkedinIn />
                            </a>
                        )}
                        {email && (
                            <a href={`mailto:${email}`} className="mentor-social-link">
                                <FaEnvelope />
                            </a>
                        )}
                        {facebookUrl && (
                            <a href={facebookUrl} target="_blank" rel="noopener noreferrer" className="mentor-social-link">
                                <FaFacebookF />
                            </a>
                        )}
                        {instagramUrl && (
                            <a href={instagramUrl} target="_blank" rel="noopener noreferrer" className="mentor-social-link">
                                <FaInstagram />
                            </a>
                        )}
                    </div>
                </div>

                <div className="col-12 col-lg-8 mentor-info-section">
                    
                    <div className="mentor-name-tagline-wrapper">
                        <h2 className="mentor-name">{name}</h2>
                        <p className="mentor-tagline">{tagline}</p>
                    </div>

                    <div className="mentor-roles">
                        {roles.map((role, index) => (
                            <span key={index}>{role}</span>
                        ))}
                    </div>
                    
                    <p className="mentor-bio">{bio}</p>

                    <div className="mentor-achievements-grid mt-3">
                        {achievements.map((item, index) => (
                            <div key={index} className="mentor-achievement-item">
                                <item.icon /> {item.text}
                            </div>
                        ))}
                    </div>

                    <div className="mentor-rating-section">
                        {rating}/5
                        <div className="mentor-rating-stars">
                            {renderStars(rating)}
                        </div>
                        <span className="mentor-review-count">({reviewsCount} Reviews)</span>
                    </div>

                    <div className="mentor-action-buttons">
                        <a href={bookingLink} className="btn-action-primary">
                            Book a Session
                        </a>
                        <a href={contactLink} className="btn-action-secondary">
                            Contact Tutor
                        </a>
                    </div>

                </div>
            </div>
        </div>
    );
};

export default AboutHackingMentor;